import 'css-chunksrc/client/scenes/workloads/wbs/quickElementLoader/styles.scss';export default {
  "quickElementLoader": "_quickElementLoader_o1ggu_1"
};